module.exports = __webpack_public_path__ + "static/media/OCFL-News-App-Page.ca51b4ec.png";